// duplicated in backend api
export const SlotsStartTimes = [
    {
        hour: 0,
        minute: 0,
    },
    {
        hour: 1,
        minute: 15,
    },
    {
        hour: 2,
        minute: 30,
    },
    {
        hour: 3,
        minute: 45,
    },
    {
        hour: 5,
        minute: 0,
    },
    {
        hour: 6,
        minute: 15,
    },
    {
        hour: 7,
        minute: 30,
    },
    {
        hour: 8,
        minute: 45,
    },
    {
        hour: 10,
        minute: 0,
    },
    {
        hour: 11,
        minute: 15,
    },
    {
        hour: 12,
        minute: 30,
    },
    {
        hour: 13,
        minute: 45,
    },
    {
        hour: 15,
        minute: 0,
    },
    {
        hour: 16,
        minute: 15,
    },
    {
        hour: 17,
        minute: 30,
    },
    {
        hour: 18,
        minute: 45,
    },
    {
        hour: 20,
        minute: 0,
    },
    {
        hour: 21,
        minute: 15,
    },
    {
        hour: 22,
        minute: 30,
    },
];
